import {
  GameSessionStatsContainer,
  StyledMaterialGrossIcon,
  StyledMaterialTimelapseIcon,
} from "../styledComponents/StyledGame";
const { printAmount } = require("../helpers/functions");

export function GameSessionStats({ gross, currency, time, server, gameWidth }) {
  return (
    <div
      style={{
        //width: gameWidth,
        alignSelf: "center",
      }}
    >
      <GameSessionStatsContainer>
        <span>
          <StyledMaterialGrossIcon />
          {gross !== null &&
            printAmount(gross, currency, server.currencies, false)}
        </span>
        <span>
          <StyledMaterialTimelapseIcon /> {time}
        </span>
      </GameSessionStatsContainer>
    </div>
  );
}
